import { Injectable } from '@angular/core';
import { Http, RequestOptions, URLSearchParams, ResponseContentType, RequestMethod, Headers } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../environments/environment';

import { Extra } from '../models/Extra';

@Injectable()
export class ExtraService {
  selectedId: string;

  get selected(): string {
    return this.selectedId;
  }
  set selected(id: string) {
    this.selectedId = id;
  }

  getExtra(id: string) {
    console.log('getExtra', id)
    return this.http.post(environment.server.url + '/extra/find-one', { id: id })
      .map(response => response.json())
  }

  persist(wmodel: any) {
    console.log('persistExtra', wmodel)
    return this.http.post(environment.server.url + '/extra/persist', { wmodel: wmodel })
      .map(response => {
        let r = response.json();
        console.log('persistExtra', r)

        return r;
      })
      .catch((err) => Observable.throw(err))
  }

  remove(wmodel: Extra) {
    console.log('removeExtra', wmodel)
    return this.http.post(environment.server.url + '/extra/remove', { wmodel: wmodel })
      .map(response => {
        let r = response.json();
        console.log('removeExtra', r)
        return r;
      })
      .catch((err) => Observable.throw(err))
  }

  search(opt) {
    console.log('extra service', opt)
    return this.http.post(environment.server.url + '/extra/search', opt)
      .map(response => response.json())
      .catch(this.handleError)
  }

  constructor(private http: Http) { }

  private handleError(error: Response | any) {
    console.error(error);
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/extra.service.ts